/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { connect } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";

import TextError from "utils/TextError";
// import { getOrgTypes } from "../../store";

// Select component
import Select from "react-select";

// Material Dashboard 2 React components
import SubscriptionHomePage from "layouts/subscription/subscriptionHomePage";
import ClientTicketsHomePage from "layouts/tickets/clientTicketsHomePage";
import TicketsHomePage from "layouts/tickets/ticketsHomePage";

import Cookies from "universal-cookie";
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { getOrgTypes } from "store";
// import { getOrgTypes } from "store";
const cookies = new Cookies();
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const Home = ({getOrgReducer, getOrgTypes}) => {
  let loginDetails = cookies.get("loginDetailsForSupport");
  let role = loginDetails?.data?.role;
  let token = loginDetails?.token;
  let clientId = loginDetails?.data?.clientId;
  let email = loginDetails?.data?.email;
  console.log("loginDetails",loginDetails)

  const [loading, setLoading] = useState(true);

  setTimeout(() => {
    setLoading(false);
  }, 500);

 const [createActivityModal, setCreateActivityModal] = useState(false);

// useEffect(() => {
//   const loginDetails = cookies.get("loginDetailsForSupport");

//   // open modal only if organization not selected
//   if (!loginDetails?.organizationsValueId) {
//     setCreateActivityModal(true);
//   }
// }, []);

  const handleCreateCloseActivityModal = () => {
    setCreateActivityModal(false);
  };

  const initialValues = {
    documentId: "",
    mvtId: "",
  };

  useEffect(() => {
    getOrgTypes(email,token);
  }, []);

  
   
// const onSubmit = async (values, { resetForm }) => {
//   const payload = {
//     documentId: documentTypeSelected?.value,
//   };

//   // ✅ store in cookies
//    cookies.set("loginDetailsForSupport", JSON.stringify(payload), {
//     expires: 7, // keep for 7 days (optional)
//     path: "/",  // available across the app
//   });

//   // let res = await createActivity(payload);

//   // if (res.status) {
//   //   setIsSuccessCreatedActivity(true);
//   //   getAllocatedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
//   //   setTimeout(() => {
//   //     setButtonName("Submit");
//   //     handleCreateCloseActivityModal();
//   //   }, 2250);
//   // }
//   // if (!res.status) {
//   //   setErrorMsg(res?.data?.data?.msg);
//   //   setIsErrorCreatedActivity(true);
//   //   setButtonName("Submit");
//   // }
// };

  const [errorMsg, setErrorMsg] = useState("");

const formik = useFormik({
  initialValues,
  onSubmit: (values) => {
    // read existing cookie object or start fresh
    let loginDetails = cookies.get("loginDetailsForSupport") || {};

    if (documentTypeSelected) {
      loginDetails.organizationsNameId = documentTypeSelected.label;
      loginDetails.organizationsValueId = documentTypeSelected.value; // ✅ store value too
    }

    // save back into cookies
    cookies.set("loginDetailsForSupport", loginDetails, {
      path: "/", 
      maxAge: 60 * 60 * 24 * 7, // 7 days
    });

    handleCreateCloseActivityModal();

    console.log("Submitted:", values);
    console.log("Saved cookie:", cookies.get("loginDetailsForSupport"));
  },
});

  const [documentTypeOptionzs, setDocumentTypeOptions] = useState([]);

  
  const [isSuccessCreatedActivity, setIsSuccessCreatedActivity] =
    useState(false);
  const [isErrorCreatedActivity, setIsErrorCreatedActivity] = useState(false);

  useEffect(() => {
    if (isErrorCreatedActivity) {
      setTimeout(() => {
        setIsErrorCreatedActivity(false);
      }, 3000);
    }
  }, [isErrorCreatedActivity]);

  useEffect(() => {
    if (isSuccessCreatedActivity) {
      setTimeout(() => {
        setIsSuccessCreatedActivity(false);
      }, 3000);
    }
  }, [isSuccessCreatedActivity]);

  
const documentTypeOptions = [
  { label: "MIT-TI", value: "2" },
  { label: "Malpani", value: "10" },
  { label: "Samsonite", value: "3" },
  { label: "test", value: "6" },
  { label: "TVS", value: "5" },
  { label: "Marico", value: "9" },
  { label: "MyLan", value: "8" },
  { label: "Stellantis", value: "11" },
  { label: "Navgurukul", value: "4" },
  { label: "Synpack", value: "12" },
  { label: "MIT-IT", value: "7" },
  { label: "Mobillor(Development)", value: "21" },
  { label: "Testing", value: "13" },
  { label: "TestingNest", value: "15" },
  { label: "TestingFromNestjs", value: "14" },
  { label: "Nerolac", value: "20" },
  { label: "Mobillor", value: "16" },
  { label: "Organization01", value: "17" },
  { label: "Organization02", value: "18" },
  { label: "Organization03", value: "19" },
  { label: "Emerson", value: "1" },
  { label: "E3W", value: "54" },
  { label: "ABC", value: "88" },
  { label: "XYZ", value: "89" },
];


  const [documentTypeSelected, setDocumentTypeSelected] = useState("");

  const handleDocumentTypeChange = (selectedDocumentType) => {
    setDocumentTypeSelected(selectedDocumentType);
  };

useEffect(() => {
  let tempDocumentTypeOptions = [];

  let data =
    getOrgReducer?.documentType?.data
      ? getOrgReducer.documentType.data
      : [];
      console.log("data",data)

  data?.forEach((document) => {
    tempDocumentTypeOptions.push({
      label: document.name,
      value: document.id,
    });
  });

  setDocumentTypeOptions(tempDocumentTypeOptions);

  // ✅ Auto select if only one record
  if (tempDocumentTypeOptions.length === 1) {
    const selected = tempDocumentTypeOptions[0];

    setDocumentTypeSelected(selected);

    let loginDetails = cookies.get("loginDetailsForSupport") || {};

    loginDetails.organizationsNameId = selected.label;
    loginDetails.organizationsValueId = selected.value;

    cookies.set("loginDetailsForSupport", loginDetails, {
      path: "/",
      maxAge: 60 * 60 * 24 * 7,
    });

    // ✅ close modal
    setCreateActivityModal(false);
  }

  // ✅ Open modal only if multiple options & not selected
  if (tempDocumentTypeOptions.length > 1) {
    let loginDetails = cookies.get("loginDetailsForSupport");

    if (!loginDetails?.organizationsValueId) {
      setCreateActivityModal(true);
    }
  }

}, [getOrgReducer]);

 return (
  <DashboardLayout>
    <DashboardNavbar />

    {!loading ? (
      <Grid container spacing={2} mt={3}>
        
        {(role?.toLowerCase() === "admin") && (
          <Grid item xs={12} md={6} lg={3} mt={2}>
            <SubscriptionHomePage />
          </Grid>
        )}

        {(role?.toLowerCase() === "admin" ||
          role?.toLowerCase() === "user") && (
          <Grid item xs={12} md={6} lg={3} mt={2}>
            <TicketsHomePage />

            {/* Hide Modal for ADMIN */}
            {role?.toLowerCase() !== "admin" && (
              <Modal
                open={createActivityModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Select
                    </MDTypography>

                    <MDBox>
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                      </IconButton>
                    </MDBox>
                  </MDBox>

                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={1}>
                        <MDTypography
                          variant="h6"
                          style={{ fontWeight: "500" }}
                        >
                          Organization
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="documentId"
                          onBlur={() => {
                            formik.handleBlur({
                              target: { name: "documentId" },
                            });
                          }}
                          value={documentTypeSelected}
                          options={documentTypeOptionzs}
                          onChange={(selectedOption) => {
                            handleDocumentTypeChange(selectedOption);
                            formik.setFieldValue("documentId", selectedOption);
                          }}
                        />

                        {formik.touched.documentId &&
                          formik.errors.documentId && (
                            <TextError msg={formik.errors.documentId} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorCreatedActivity}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorCreatedActivity(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>

                        <Collapse in={isSuccessCreatedActivity}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessCreatedActivity(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Successfully
                          </Alert>
                        </Collapse>
                      </MDBox>

                      <MDBox mt={3}>
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
            )}
          </Grid>
        )}

        {(role?.toLowerCase() === "executive") && (
          <Grid item xs={12} md={6} lg={3} mt={2}>
            <ClientTicketsHomePage />
          </Grid>
        )}

      </Grid>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "100px",
          marginBottom: "100px",
        }}
      >
        <CircularProgress color="info" />
      </div>
    )}

    <Footer />
  </DashboardLayout>
);
};

const mapStateToProps = (state) => {
  return {
    getOrgReducer: state.getOrgReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getOrgTypes: (email,token) => dispatch(getOrgTypes(email,token)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Home);
